import React, { forwardRef, useEffect } from "react";
import { Slider as MuiSlider, styled, Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import Button from "../Button";
// import Tooltip from "./Tooltip";

const GradiousSlider = styled(MuiSlider)(({ theme, value }) => {
  // Ensure we have valid values and sort them
  const [val0, val1, val2 = 100] = value || [0, 100];
  const minVal = Math.min(val1, val2);
  const maxVal = Math.max(val1, val2);

  //   const minPercent = minVal;
  //   const maxPercent = maxVal;

  return {
    color: "transparent",
    height: 8,
    "& .MuiSlider-rail": {
      backgroundColor: "#c1c4cb",
      height: "8px",
      borderRadius: "4px",
      opacity: 1,
    },
    "& .MuiSlider-track": {
      height: "8px",
      borderRadius: "4px",
      // right: "auto !important",
      backgroundClip: "content-box !important",
      // Create the gradient based on the actual thumb positions
      background: `linear-gradient(
        to right,
        red ${val0}%, 
        red ${minVal}%,
        orange ${minVal}%, 
        orange ${maxVal}%,
        #c1c4cb ${maxVal}%, 
        #c1c4cb 100%
      )`,
      // Override the default track behavior
      left: "0 !important",
      width: "100% !important",
    },
    "& .MuiSlider-thumb": {
      width: "16px",
      height: "16px",
      backgroundColor: "white",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      border: "2px solid transparent",
      "&:hover": {
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
      },
      "&::before": {
        display: "none",
      },
      // Style individual thumbs differently if needed
      "&[data-index='0']": {
        borderColor: "red",
      },
      "&[data-index='1']": {
        borderColor: "orange",
      },
      "&[data-index='2']": {
        borderColor: "orange",
      },
    },
    "& .MuiSlider-valueLabel": {
      display: "none",
      "&::before": { display: "none" },
    },
  };
});

const Text = styled(Typography)(() => ({
  fontFamily: "Inter",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0",
  verticalAlign: "middle",
  color: "#101828",
}));

function ValueLabelComponent({ children, value, open }) {
  return React.cloneElement(children, {
    children: (
      <>
        {children.props.children}
        {open && (
          <span
            style={{
              position: "absolute",
              top: "-32px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#101828",
              color: "#fff",
              padding: "2px 6px",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
          >
            {value}%
          </span>
        )}
      </>
    ),
  });
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.node,
  isTooltip: PropTypes.bool,
};

const applyColorFilter = ({ value, setNewValue }) => {
  setNewValue(value);
};

const DoubleSlider = forwardRef(({ isTooltip = false, ...props }, ref) => {
  const arraysEqual = (a, b) =>
    a.length === b.length && a.every((val, i) => val === b[i]);

  const isDisable = arraysEqual(props.value, props.newValue);

  useEffect(() => {
    console.log("✅ NewValue updated:", props.newValue);
  }, [props.newValue]);

  return (
    <div className="report-time-spent-slider">
      <div className="report-time-spent-slider-legend">
        <p className="report-time-spent-colorname-1">
          <div style={{ display: "flex", width: "81px", height: "20px" ,gap:"6px", alignItems:"center" }}>
            <div
              style={{
                backgroundColor: "#F04438",
                width: "12px",
                height: "12px",
                borderRadius: "100%",
              }}
            ></div>
            <div className="report-time-spent-slider-legend-color1">{`Red:`}</div>
          </div>
          <div className="report-time-spent-slider-legend-name1">{`${props.newValue[0]}% - ${props.newValue[1]}%`}</div>
        </p>

        <p className="report-time-spent-colorname-2">
          <div style={{ display: "flex", width: "80px", height: "20px",gap:"6px", alignItems:"center" }}>
            <div
              style={{
                backgroundColor: "#F79009",
                width: "12px",
                height: "12px",
                borderRadius: "100%",
              }}
            ></div>
            <div className="report-time-spent-slider-legend-color2">{`Amber:`}</div>
          </div>
          <div className="report-time-spent-slider-legend-name2">{`${props.newValue[1]}% - ${props.newValue[2]}%`}</div>
        </p>
      </div>
      <div className="report-time-spent-slider-component">
        <div className="report-time-spent-slider-marker">
          <div style={{ display: "flex", justifyContent: "space-between", height: "14px" }}>
            <div className="report-time-spent-slider-marker-start">0</div>
            <div className="report-time-spent-slider-marker-end">100</div>
          </div>
          <GradiousSlider
            ref={ref}
            {...props}
            slots={{
              valueLabel: ValueLabelComponent,
            }}
            valueLabelDisplay="auto"
          />
        </div>
        <Button
          size="sm"
          hierarchy={{
            type: "tertiaryGrey",
            buttonText: "Apply",
          }}
          onClick={() => {
            applyColorFilter(props);
          }}
          disable={isDisable}
        />
      </div>
    </div>
  );
});

export default DoubleSlider;
